// deleteipwhitelistaction.js
import { partnerServices } from "../../config/axios";

export const DELETE_IP_WHITELIST_REQUEST = 'DELETE_IP_WHITELIST_REQUEST';
export const DELETE_IP_WHITELIST_SUCCESS = 'DELETE_IP_WHITELIST_SUCCESS';
export const DELETE_IP_WHITELIST_FAILURE = 'DELETE_IP_WHITELIST_FAILURE';


export const deleteIpWhitelistAction = (requestData, authToken) => async (dispatch) => {
    dispatch({ type: DELETE_IP_WHITELIST_REQUEST });
    await partnerServices
        .post("deleteIpWhitelist", requestData, {
            headers: { AuthToken: authToken }
        })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: DELETE_IP_WHITELIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: DELETE_IP_WHITELIST_FAILURE, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: DELETE_IP_WHITELIST_FAILURE, payload: err.message });
        });
};